import { memo } from 'react';

import { DataTable, NoDataMessage, useDataTable } from '@/_containers';

import { useDefineColumns } from './use-define-columns';

import type { PaymentMethodFieldFormRowSchema } from '../../schemas/payment-method-field-query-schema';

type PaymentMethodFieldsTableProps = {
  tableData: PaymentMethodFieldFormRowSchema[];
  isEditable: boolean;
  onEdit: (row: PaymentMethodFieldFormRowSchema) => void;
  onDelete: (id: number) => void;
};

function PaymentMethodFieldsTableBase({ tableData, isEditable, onEdit, onDelete }: PaymentMethodFieldsTableProps) {
  const columns = useDefineColumns({ isEditable, onEdit, onDelete });
  const table = useDataTable({
    columns,
    data: tableData,
    getRowId: (row) => `${row.id}`,
  });

  if (tableData.length < 1) {
    return <NoDataMessage message="No payment method fields configured" className="mt-8" />;
  }

  return (
    <div className="mt-4">
      <DataTable table={table} />
    </div>
  );
}

export const PaymentMethodFieldsTable = memo(PaymentMethodFieldsTableBase);
